import React from 'react';
import styled from 'styled-components';

import Button from '../../../Button';
import Input from '../../../Input';

import { Dial as Icon } from '@icons/dialer';

export interface DialProps {
  className?: string;
  onTone: (key: string) => void;
}

interface DialState {
  value: string;
  isOpen: boolean;
}

class Dial extends React.PureComponent<DialProps, DialState> {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      isOpen: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
  }

  handleChange({ target }) {
    this.setState({ value: target.value });
  }

  handleKeyDown(ev) {
    const { onTone } = this.props;
    const isAcceptedKey = /[0-9|*|#]/g.test(ev.key);
    if (isAcceptedKey) {
      onTone(ev.key);
    } else {
      ev.preventDefault();
    }
  }

  handleToggle() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  }

  render() {
    const { isOpen, value } = this.state;
    return (
      <StyledDial {...this.props}>
        <StyledDialIcon onClick={this.handleToggle}>
          <Icon />
        </StyledDialIcon>
        <StyledInput
          open={isOpen}
          onChange={this.handleChange}
          onKeyDown={this.handleKeyDown}
          placeholder="Доб. номер"
          value={value}
        />
      </StyledDial>
    );
  }
}

const StyledDial = styled.div`
  background-color: #17181a;
  border: 1px solid #4d4d4d;
  border-radius: 20px;
  display: flex;
  height: 40px;
`;

const StyledDialIcon = styled(Button)`
  background-color: transparent;
  border: none;
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  height: 40px;
  position: absolute;
  width: 40px;
  z-index: 2;

  > svg {
    margin: auto;
    rect {
      stroke: #4d4d4d;
    }
  }
`;

const StyledInput = styled(Input)`
  background-color: transparent;
  border: none;
  box-sizing: border-box;
  color: #fff;
  font-size: 14px;
  padding: 0 0 0 40px;
  width: 0px;
  line-height: 38px;
  transition: width 300ms;
  transform: translate3d(0, 0, 0);

  ${props =>
    props.open &&
    `
    padding-right: 15px;
    width: 147px;
  `}
`;

export default Dial;
